module.exports = __webpack_public_path__ + "img/insert-02-gauche.04fb91b0.svg";